<template>
  <c-page class="s-actionsheet">
    <c-content>
      <div class="industry-container">
        <div class="sales-item-block">
          <div
            class="ds-flex sales-item item-one"
            v-if="userInfo.saasOrderCount<= 0"
          >
            <div class="item-header">
              <div class="text-color item-title">1个月</div>
              <div class="text-color gray item-desc">自动续约，可随时取消</div>
            </div>
            <div class="item-footer">
              <span class="text-color orange price">￥<span class="font-middle">60</span></span>
              <span
                class="buy-btn"
                @click="openActionSheet('month')"
              >购买</span>
            </div>
          </div>
          <div class="ds-flex sales-item item-two">
            <div class="item-header">
              <div class="text-color item-title">
                12个月
                <span v-if="!isTestOldUser"><img
                    class="item-tag"
                    src="../../../assets/images/industry-version/sale-tag@2x.png"
                    alt=""
                  ></span>
                <span v-else><img
                    class="item-old-tag"
                    src="../../../assets/images/industry-version/old@2x.png"
                    alt=""
                  ></span>
              </div>
              <div class="text-color gray item-desc">赚钱的实体店都在用</div>
            </div>
            <div class="item-footer">
              <span class="text-color gray oriPrice">￥{{priceObj.oriPrice}}</span>
              <span class="text-color orange price">￥<span class="font-middle">{{priceObj.salePrice}}</span></span>
              <span
                class="buy-btn"
                @click="openActionSheet('year')"
              >购买</span>
            </div>
          </div>
        </div>
        <c-images :img-items="images"></c-images>
        <div
          class="overlay-mask"
          @click="openProtocol"
        >
          <div class="overlay-mask-one"></div>
        </div>
      </div>
    </c-content>
    <c-footer class="footer-shadow">
      <c-button @click.native="openActionSheet('year')">
        <div>立即购买</div>
      </c-button>
    </c-footer>
    <c-action-sheet :visible.sync="actionsheetShow">
    <div
      class="close-btn"
      @click="closeActionSheet"
    ><i class="s-icon-close"></i></div>
    <div slot="menu">
      <div class="industry-wrap">
        <industry-modal
          :default-type.sync="goodsBuyType"
          :price-obj.sync="priceObj"
          :version-entity="industyEntity"
          @pay="buy"
        ></industry-modal>
      </div>
      </div>
    </c-action-sheet>
  </c-page>
</template>
<style lang="scss" scoped>
@import "../../../assets/scss/base/__mixin";
@import "./index";

.footer-shadow {
  box-shadow: 0 0 px2rem(3px) gray;
}

.small-text {
  @include font-dpr(10px);
  margin-top: px2rem(-33px);
}
</style>
<script>
import Pay from '../../../model/pay'
import debounce from 'lodash.debounce'
import Vas from '../../../model/value-added-service'
import IndustryModal from './_cell/industry-modal'
import IndustryVersionEntity from '../../../model/industry-version/industry-entity'

export default {
  data () {
    return {
      IndustryVersionEntity,
      vas: new Vas(),
      images: [
        require('@/assets/images/industry-version/1@2x.png'),
        require('@/assets/images/industry-version/2@2x.png'),
        require('@/assets/images/industry-version/3@2x.png')
      ],
      pay: new Pay(),
      actionsheetShow: false,
      industyEntity: [],
      oldUser: {
        oriPrice: '588',
        salePrice: '288'
      },
      newUser: {
        oriPrice: '720',
        salePrice: '599'
      },
      goodsBuyType: 'year',
      priceObj: {
        oriPrice: '',
        salePrice: ''
      }
    }
  },
  components: { IndustryModal },
  created () {
  },
  mounted () {
    this.$store.dispatch('userInfo/loadUserInfo')
  },
  beforeDestroy () {
  },
  methods: {
    buy: debounce(function (val) {
      if (!this.vas.isCanBuy()) {
        this.$wejs.alert(this.vas.getErrorMess())
        return
      }
      this.closeActionSheet()
      this.pay.thirdPartyPay(val.goodsId, val.quantity)
    }, 220),
    openLaws () {
      this.$router.push('/user-protocol')
    },
    goToProtocol () {
      this.$router.push('/apple-auto-renew-protocol')
    },
    openActionSheet (val) {
      console.log('openActionSheet', val)
      this.goodsBuyType = val
      this.actionsheetShow = true
    },
    closeActionSheet () {
      this.actionsheetShow = false
    },
    industryEntityFunc () {
      let entity = this.IndustryVersionEntity.industryVersion
      this.userInfo.avaliableBusIds.forEach(item => {
        entity.forEach(cItem => {
          if (cItem.id === item) cItem.isAvailable = true
        })
      })
      return entity
    },
    openProtocol () {
      this.$router.push('/service-protocol')
    }
  },
  computed: {
    userInfo: {
      get () {
        return this.$store.getters[`userInfo/getUserInfo`]
      }
    },
    isTestOldUser () {
      return this.userInfo.isTestOldUser
    }
  },
  watch: {
    userInfo: {
      handler: function (val) {
        // this.priceObj = val.isTestOldUser ? this.oldUser : this.newUser
        this.priceObj = this.newUser
        this.industyEntity = this.industryEntityFunc()
      },
      deep: true
    }
  },
  events: {}
}
</script>



// WEBPACK FOOTER //
// index.vue?0e342838